var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-combo-box", {
    staticClass: "modal-content__ftp",
    attrs: {
      label: _vm.label,
      "data-set": _vm.options,
      "selected-items": [_vm.selectedOption],
      error: !_vm.options.length,
      disabled: !_vm.options.length,
      errorText: [_vm.translate("scheduler.modal.delivery.ftp.error")],
    },
    on: { input: _vm.handleEvent },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }